import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessages = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M28 6H4C3.45 6 3 6.45 3 7V24C3 24.53 3.21 25.04 3.59 25.41C3.97 25.78 4.47 26 5 26H27C27.53 26 28.04 25.79 28.41 25.41C28.78 25.03 29 24.53 29 24V7C29 6.45 28.55 6 28 6ZM27 22.73L19.66 16L27 9.28V22.73ZM5 9.27L12.34 15.99L5 22.72V9.27ZM6.57 8H25.43L16 16.64L6.57 8ZM13.81 17.35L15.32 18.73C15.51 18.9 15.75 18.99 16 18.99C16.25 18.99 16.48 18.9 16.68 18.73L18.19 17.35L25.44 24H6.57L13.82 17.35H13.81Z" })
});
export default SvgMessages;
